import React, { useReducer, useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  useColorModeValue,
  useColorMode,
  Image,
} from "@chakra-ui/react";
// Assets

import { FaCube, FaPenFancy } from "react-icons/fa";
import { IoDocumentsSharp } from "react-icons/io5";
import { EmailBlastIconLight } from "components/Icons/Icons.js";
import andrewBigbrain from "assets/img/avatars/andrew_bigbrain.png";

// Templates
import New from "views/Applications/Templates/New";
import Used from "views/Applications/Templates/Used";
import Custom from "views/Applications/Templates/Custom";

// api calls
import { getClients } from "api/requests/getClients.js";

const reducer = (state, action) => {
  if (action.type === "SWITCH_ACTIVE") {
    if (action.payload === "used") {
      const newState = {
        used: true,
        new: false,
        custom: false,
      };
      return newState;
    } else if (action.payload === "new") {
      const newState = {
        used: false,
        new: true,
        custom: false,
      };
      return newState;
    } else if (action.payload === "custom") {
      const newState = {
        used: false,
        new: false,
        custom: true,
      };
      return newState;
    }
  }
  return state;
};

function EmailBlastTool() {
  const [state, dispatch] = useReducer(reducer, {
    used: false,
    new: true,
    custom: false,
  });

  const [activeTemplate, setActiveTemplate] = useState("New");
  const { colorMode } = useColorMode();
  const bgColor = useColorModeValue("white", "#4A5058");
  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");
  const bgHead = useColorModeValue("hsla(0,0%,100%,.8)", "navy.800");
  const borderHeadColor = useColorModeValue("white", "transparent");
  const bgButton = useColorModeValue(
    "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)",
    "blue.500"
  );
  const bgBadge = useColorModeValue("gray.100", "navy.900");

  const [clients, setClients] = useState([]);
  const [titles, setTitles] = useState([]);

  const fetchClients = async () => {
    const data = await getClients();
    const updatedClients = [...data];
    setClients(updatedClients);
    setTitles(
      data.map((title) => ({
        value: title.value,
        label: title.label,
      }))
    );
  };

  const handleClientUpdate = async () => {
    await fetchClients(); // Re-fetch clients after update
  };

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <Flex direction="column" pt={{ sm: "125px", lg: "75px" }}>
      <Box
        borderRadius="4px"
        px="0px"
        mb={"15px"}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        align="center"
        border="1px solid"
        borderColor={borderHeadColor}
      >
        <Flex
          direction={{ sm: "column", md: "row" }}
          maxH="330px"
          justifyContent={{ sm: "center", md: "space-between" }}
          align="center"
          backdropFilter="blur(21px)"
          boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
          bg={bgColor}
          p="24px"
          borderRadius="4px"
        >
          <Flex
            align="center"
            mb={{ sm: "10px", md: "0px" }}
            direction={{ sm: "column", md: "row" }}
            w={{ sm: "100%" }}
            textAlign={{ sm: "center", md: "start" }}
          >
            <EmailBlastIconLight w="80px" h="80px" me={{ md: "22px" }} />
            <Flex direction="column" maxWidth="100%" my={{ sm: "14px" }}>
              <Text
                fontSize={{ sm: "lg", lg: "xl" }}
                fontWeight="bold"
                ms={{ sm: "8px", md: "0px" }}
                color={textColor}
              >
                Email Blast Builder
              </Text>
              <Text fontSize={{ sm: "sm", md: "md" }} color="green.300">
                v4.0.0
              </Text>
            </Flex>
            <Image
              borderRadius="10px"
              src={andrewBigbrain}
              p={"5px"}
              w={"60px"}
              ml={"10px"}
            />
          </Flex>
        </Flex>
      </Box>
      <Box>
        <New
          clientData={clients}
          titleData={titles}
          onClientUpdate={handleClientUpdate}
        />
      </Box>
    </Flex>
  );
}

export default EmailBlastTool;
